// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1497":"7d2f3b3a","8959":"7d2f3b3a"}[chunkId] + ".chunk.css";
};